module.exports = __webpack_public_path__ + "static/media/kestrel-logo.54671a62.svg";